import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Button from 'helpers/Button';

const SubmitBtn = ({isMobile, loading, brandLogo, joinProgram, btncolor, submitForm, translations}) => {
  const customBtnColor = Boolean(btncolor);
  const {joinFSAffiliateProgram, search} = translations;

  return (
    <div className="grid no-gutter bottom-aff">
      <div
        style={isMobile ? {} : {flex: '0 0 55%', maxWidth: '55%'}}
        className="grid-item d-flex flex-column justify-content-center"
      >
        <img
          src={brandLogo}
          alt='logo'
          title='logo'
          width='130px'
        />
        {
          joinProgram &&
            <div>
              <a
                className="text-small"
                href="https://ferryscanner.tapfiliate.com/programs/ferryscanner-affiliate-program/signup/"
                target="_blank"
                rel="noreferrer"
              >
                {joinFSAffiliateProgram}    
              </a>
            </div>
        }
      </div>
      <Button
        isLoading={loading}
        aria-label={search}
        status="primary"
        className="grid-item btn-block"
        style={customBtnColor ? {backgroundColor: btncolor, borderColor: btncolor, borderRadius: '0px'} : undefined}
        onClick={submitForm}
      >
        {search}
      </Button>
    </div>
  );
};

SubmitBtn.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  brandLogo: PropTypes.string.isRequired,
  joinProgram: PropTypes.bool.isRequired,
  btncolor: PropTypes.string.isRequired,
  submitForm: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    search: PropTypes.string.isRequired,
    joinFSAffiliateProgram: PropTypes.string.isRequired
  })
};

export default observer(SubmitBtn);

